import { PostHogProvider } from "posthog-js/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const AnalyticsProvider = ({ children }: { children: React.ReactNode }) => {
  if (process.env.NODE_ENV === "development") return <>{children}</>;

  return <PostHogProvider apiKey="phc_PYbpRscP9jd7AQEi3zPr2cMEAkQTd2QcKXW6hR3KNfv">{children}</PostHogProvider>;
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <AnalyticsProvider>
      <App />
    </AnalyticsProvider>
  </React.StrictMode>
);
